module.exports = __webpack_public_path__ + "static/media/bg_plan_suggestion_from_35_to_39.449b7ea8.webp";